var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    fill: "#F1F2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.54 15.42C31.4212 14.9454 31.1793 14.5106 30.8386 14.1594C30.498 13.8082 30.0707 13.5532 29.6 13.42C27.88 13 21 13 21 13C21 13 14.12 13 12.4 13.46C11.9292 13.5932 11.502 13.8482 11.1613 14.1994C10.8207 14.5506 10.5788 14.9854 10.46 15.46C10.1452 17.2056 9.99123 18.9763 9.99999 20.75C9.98877 22.537 10.1428 24.3213 10.46 26.08C10.591 26.5398 10.8383 26.9581 11.1781 27.2945C11.518 27.6308 11.9388 27.8738 12.4 28C14.12 28.46 21 28.46 21 28.46C21 28.46 27.88 28.46 29.6 28C30.0707 27.8668 30.498 27.6118 30.8386 27.2606C31.1793 26.9094 31.4212 26.4746 31.54 26C31.8524 24.2676 32.0063 22.5103 32 20.75C32.0112 18.963 31.8572 17.1787 31.54 15.42V15.42Z",
    stroke: "#0050F0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 24.02L24.5 20.75L18.75 17.48V24.02Z",
    stroke: "#0050F0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.055186007add317c628d6f6f743d0120.svg";
export { ForwardRef as ReactComponent };